import { useRouter } from 'next/router';
import React from 'react';

import { LoginComponent } from '@app/components/auth/LoginComponent';
import { withLayout } from '@components/withLayout';

const LoginPage: React.FC = () => {
  const router = useRouter();

  const handleLogin = (isLogin: boolean) => {
    if (isLogin) {
      const callbackUrl = (router.query?.callbackUrl as string) || undefined;
      const storedReturnUrl =
        typeof window !== 'undefined' ? sessionStorage.getItem('returnUrl') : undefined;
      const nextUrl = storedReturnUrl || callbackUrl || '/';

      if (storedReturnUrl) sessionStorage.removeItem('returnUrl');

      // Chỉ cho phép push các đường dẫn nội bộ bắt đầu bằng '/'
      const safeUrl = typeof nextUrl === 'string' && nextUrl.startsWith('/') ? nextUrl : '/';
      router.push(safeUrl);
    }
  };

  return <LoginComponent onLogin={handleLogin} />;
};

export default withLayout(LoginPage);
